<template>
    <div>
        <a-auto-complete
            :data-source="dataSource"
            style="width: 100%;"
            :value="address"
            :disabled="disabled"

        >
            <a-textarea
                :placeholder="placeholder"
                :style="{height: '80px', width: '100%', fontSize: '18px',fontWeight: '500'}"

            />
        </a-auto-complete>
        <div ref="placeAutocomplete"></div>
    </div>
</template>

<script lang="js">
import {gmapApi} from 'gmap-vue';
import debounce from "lodash/debounce";

export default {
    model: {
        event: "change",
        prop: "address"
    },

    props: {
        address: String,
        placeholder: {
            required: false,
            default: "Nhập địa chỉ"
        },
        prefix: String,
        disabled: {
            required: false,
            default: false
        }
    },

    data() {
        return {
            dataSource: []
        }
    },
    computed: {
        google: gmapApi
    },

    methods: {
        onSelect(val) {
            if (!val) return;
            this.$gmapApiPromiseLazy().then(() => {
                const request = {
                    placeId: val,
                    fields: ["address_components", "formatted_address", "place_id", "geometry"],
                };
                const servicePlace = new this.google.maps.places.PlacesService(this.$refs.placeAutocomplete);
                servicePlace.getDetails(request, this.responsePlaceDetail);
            });
        },
        onAddressChange($evt) {
            // this.handleAddressChange($evt.target.value, this);
            this.$emit("change", $evt.target.value);
        },
        responsePlacePrediction(predictions, status) {
            if (status !== this.google.maps.places.PlacesServiceStatus.OK) return;
            this.dataSource = predictions.map(item => ({
                value: item.place_id,
                text: item.description
            }))
        },
        responsePlaceDetail(place, status) {
            if (status !== this.google.maps.places.PlacesServiceStatus.OK) return;
            this.$emit("change", place.formatted_address);
            this.$emit("place-changed", place);
        },
        handleAddressChange: debounce(function (evt, vm) {
            const value = evt.target.value;
            this.$emit("change", value);
            if (!value) return;
            this.$gmapApiPromiseLazy().then(() => {
                const service = new this.google.maps.places.AutocompleteService();
                const sessionToken = new this.google.maps.places.AutocompleteSessionToken();
                const input = this.prefix ? this.prefix + ' ' + value : value;
                service.getPlacePredictions({
                    input: input,
                    componentRestrictions: {country: "vn"},
                    types: ["geocode", "establishment"],
                    sessionToken: sessionToken
                }, this.responsePlacePrediction);

            })
        }, 900)
    },
}
</script>

<style scoped>

</style>